import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NotificacaoComponent } from 'src/app/shared/components/notificacao/notificacao.component';

@Injectable({
  providedIn: 'root',
})
export class NotificacaoService {
  constructor(private snackBar: MatSnackBar) {}

  private color!: string;

  show(
    mensagem: string,
    textoBotao: string,
    tipoMensagem: 'error' | 'success' | 'alert'
  ) {
    if (tipoMensagem == 'success') this.color = 'background-green';
    if (tipoMensagem == 'error') this.color = 'background-red';

    this.snackBar.openFromComponent(NotificacaoComponent, {
      data: {
        message: mensagem,
        buttonText: textoBotao,
        type: tipoMensagem,
      },
      duration: 5000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: [tipoMensagem, this.color],
    });
  }
}
